import { render, staticRenderFns } from "./chartBox.vue?vue&type=template&id=0f0d3ae2&scoped=true&"
import script from "./chartBox.vue?vue&type=script&lang=js&"
export * from "./chartBox.vue?vue&type=script&lang=js&"
import style0 from "./chartBox.vue?vue&type=style&index=0&id=0f0d3ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d3ae2",
  null
  
)

export default component.exports